import React from "react";

function Forbidden() {
  return (
    <div className="flex flex-col h-screen justify-center items-center ">
      <div>
        <h1 className="text-9xl text-slate-800">403</h1>
      </div>
      <div>
        <p className="text-xl text-center">
          The page operation you are looking for is forbidden.
        </p>
      </div>
      <div>
        <a
          href="/"
          className="text-xl text-sky-500 underline underline-offset-4"
        >
          Back to Home
        </a>
      </div>
    </div>
  );
}

export default Forbidden;
